<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
    y="0px" width="24" height="24" viewBox="0 0 512 512" :fill="fill || 'black'" style="enable-background:new 0 0 459.093 459.093;" xml:space="preserve">
    <g>
      <g>
        <g>
          <path d="M361.796,280.561c27.986-14.565,45.711-43.442,45.711-75.397c0-46.906-38.154-85.067-85.05-85.067
				c-8.428,0-16.79,1.242-24.849,3.7l4.475,14.694c6.612-2.014,13.466-3.034,20.378-3.034c38.427,0,69.69,31.27,69.69,69.707
				c0,28.126-16.753,53.333-42.633,64.215c-4.82,1.987-7.936,6.636-7.936,11.841c0,5.509,3.608,10.486,8.673,12.07
				c0.758,0.253,1.707,0.498,1.799,0.526c51.483,12.909,88.156,57.511,91.436,109.964h-77.305v15.36h92.901v-7.68
				C459.087,350.729,419.345,297.747,361.796,280.561z" :stroke="fill || 'black'" stroke-width="15" />
          <path d="M217.453,244.123c38.11-17.353,62.553-55.177,62.553-97.249c0-58.955-47.971-106.919-106.936-106.919
				c-58.952,0-106.916,47.964-106.916,106.919c0,42.063,24.433,79.882,62.539,97.253C52.811,264.187,0,332.682,0,411.459v7.68
				h346.133v-7.68C346.132,332.638,293.28,264.115,217.453,244.123z M15.544,403.779c3.325-69.188,51.33-128.317,119.122-145.333
				c0,0,1.191-0.314,1.932-0.563c5.748-1.768,9.762-7.308,9.762-13.466c0-5.775-3.444-10.947-8.759-13.158
				c-34.068-14.319-56.081-47.439-56.081-84.388c0-50.487,41.073-91.559,91.556-91.559c50.497,0,91.576,41.073,91.576,91.559
				c0,36.953-22.026,70.079-56.105,84.384c-5.311,2.232-8.745,7.397-8.745,13.162c0,6.158,4.011,11.691,9.632,13.428
				c0.891,0.29,2.041,0.601,2.154,0.631c67.683,16.985,115.674,76.111,119.002,145.302H15.544z" :stroke="fill || 'black'" stroke-width="15" />
        </g>
      </g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ReviewerIcon',
  props: {
    fill: String
  }
};
</script>
